import React from 'react';
import {SalesforceContactField} from 'api';
import {SelectItem as Select} from './Select';
import {Checkbox, Date, Reference, Text} from '../FieldItem';
import {MultiSelectItem} from './MultiSelect';

interface Props {
  addition: {[key: string]: any};
  setAddition: Function;
  field: SalesforceContactField;
}

export const Field = ({addition, setAddition, field}: Props) => {
  switch (field.fieldType) {
    case 'checkbox':
      return (
        <Checkbox addition={addition} setAddition={setAddition} field={field} />
      );
    case 'date':
      return (
        <Date addition={addition} setAddition={setAddition} field={field} />
      );
    case 'select':
      return (
        <Select addition={addition} setAddition={setAddition} field={field} />
      );
    case 'reference':
      return (
        <Reference
          addition={addition}
          setAddition={setAddition}
          field={field}
        />
      );
    case 'multi_select':
      return (
        <MultiSelectItem
          addition={addition}
          setAddition={setAddition}
          field={field}
        />
      );
    default:
      return (
        <Text addition={addition} setAddition={setAddition} field={field} />
      );
  }
};
